import React from 'react';
import FontAwesome from 'react-fontawesome';

/**
 * Extremely simple spinner, using FontAwesome markup
 * */
const Spinner = () => <FontAwesome name="spinner" spin />;

/** @component */
export default Spinner;
